import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-Centers',
  templateUrl: './Centers.component.html',
  styleUrls: ['./Centers.component.css']
})
export class CentersComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }
  public back() {
    this.location.back();
  }

}
